import { CancelMembershipComponent } from './cancel-membership/cancel-membership.component';
import { ChangeMembershipComponent } from './change-membership/change-membership.component';
import { ConfirmationAccountComponent } from './confirmation-account/confirmation-account.component';
import { GiftsComponent } from './gifts/gifts.component';
import { HomeComponent } from './home/home.component';
import { OffersComponent } from './offers/offers.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PaymentComponent } from './payment/payment.component';
import { UpdateBillingComponent } from './update-billing/update-billing.component';
import { ActivatedRouteSnapshot, Route } from '@angular/router';
import { environment } from '@tytapp/environments/environment';
import { AssumeComponent } from 'app/assume/assume.component';
import { CancelMembershipSuccessPageComponent } from 'app/cancel-membership-success-page/cancel-membership-success-page.component';
import { ChangeEmailSuccessPageComponent } from 'app/change-email-success-page/change-email-success-page.component';
import { ForgotComponent } from 'app/forgot/forgot.component';
import { NoticeTestComponent } from 'app/notice-test/notice-test.component';
import { RedirectComponent } from 'app/redirect/redirect.component';
import { UpdateBillingSuccessPageComponent } from 'app/update-billing-success-page/update-billing-success-page.component';
import { LoginComponent, LogoutComponent } from '../user';
import { ChangeMembershipConfirmationComponent } from './change-membership-confirmation/change-membership-confirmation.component';
import { ChangeMembershipSuccessPageComponent } from './change-membership-success-page/change-membership-success-page.component';
import { CommunicationPreferenceComponent } from './communication-preference/communication-preference.component';
import { ConfirmedOffersComponent } from './confirmed-offers/confirmed-offers.component';
import { GiftRedemptionComponent } from './gift-redemption/gift-redemption.component';
import { NewsletterFormComponent } from './newsletter-form/newsletter-form.component';
import { NoOpComponent } from './no-op.component';
import { SettingsComponent } from './settings/settings.component';
import { SponsorshipViewComponent } from './sponsorship-view/sponsorship-view.component';
import { SponsorshipsComponent } from './sponsorships/sponsorships.component';
import { SsoComponent } from './sso/sso.component';
import { MembershipPogBarComponent } from './membership-pog-bar/membership-pog-bar.component';
import { ContributionPogBarComponent } from './contribution-pog-bar/contribution-pog-bar.component';
import { PageShellComponent } from './page-shell/page-shell.component';
import { BounceToAppComponent } from './bounce-to-app.component';

export const ROUTES: Route[] = [
    /* EMBEDS */

    {
        path: 'membership-pog-bar',
        component: MembershipPogBarComponent
    },
    {
        path: 'contribution-pog-bar',
        component: ContributionPogBarComponent
    },

    /* JOIN PATH */

    {
        path: 'join',
        component: OffersComponent
    },
    {
        path: 'join/m/:id/:offerId/confirmed',
        data: { urlStyle: 'modern' },
        component: ConfirmedOffersComponent
    },
    {
        path: 'join/m/:id/:offerId/:step',
        data: { urlStyle: 'modern' },
        component: OffersComponent
    },
    {
        path: 'join/:id',
        data: { urlStyle: 'classic' },
        component: OffersComponent
    },
    {
        path: 'join/:id/:alternateOfferId',
        data: { urlStyle: 'classic' },
        component: OffersComponent
    },
    {
        path: 'offers/:id',
        data: { urlStyle: 'classic' },
        component: OffersComponent
    },
    {
        path: 'offers',
        data: { urlStyle: 'classic' },
        component: OffersComponent
    },

    // STANDARD PAGES

    {
        path: '',
        component: PageShellComponent,
        children: [

            {
                path: '',
                component: HomeComponent,
                pathMatch: 'full'
            },

            /* SSO */
            {
                path: 'sso',
                component: SsoComponent
            },

            /* DEVELOPER TOOLS */
            {
                path: 'dev/test/notice',
                component: NoticeTestComponent
            },

            { path: 'signup', redirectTo: '/join' },
            { path: 'signup/:offerSetUUID/:offerUUID', redirectTo: '/join' },
            
            {
                path: 'gift/redemption/:code',
                component: GiftRedemptionComponent
            },
            {
                path: 'gift',
                component: GiftsComponent
            },
            {
                path: 'gift/:step',
                component: GiftsComponent
            },
            {
                path: 'gift/:step/:item',
                component: GiftsComponent
            },
            {
                path: 'gifts',
                redirectTo: '/gift'
            },
            {
                path: 'gifts/redemption',
                redirectTo: '/gift/redemption'
            },
            {
                path: 'sponsorship',
                component: SponsorshipsComponent
            },
            {
                path: 'sponsorship/:step',
                component: SponsorshipsComponent
            },
            {
                path: 'sponsorship/:step/:item',
                component: SponsorshipsComponent
            },
            {
                path: 'sponsorships',
                redirectTo: '/sponsorship'
            },
            {
                path: 'sponsorship-toolkit',
                component: NoOpComponent,
                resolve: { _: 'TYTAppRedirect' },
                data: { path: '/resources/gift-membership-packages/toolkit' }
            },
            {
                path: 'sponsorship-view/:code/:number',
                component: SponsorshipViewComponent
            },
            {
                path: 'amplify',
                redirectTo: '/join'
            },
            {
                path: 'validateEmail',
                component: NoOpComponent,
                resolve: { _: 'TYTAppRedirect' },
                data: { path: '/validate-email' }
            },
            {
                path: 'validateEmail/:token',
                component: NoOpComponent,
                children: [],
                resolve: {
                    _: 'TYTAppRedirect'
                },
                data: {
                    path: '/validate-email/:token'
                }
            },
            {
                path: 'payment/:offerSetUUID/:offerUUID',
                component: PaymentComponent
            },
            {
                path: 'login',
                component: LoginComponent
            },
            {
                path: 'login/forgot/:token',
                component: ForgotComponent
            },
            {
                path: 'login/forgot',
                component: ForgotComponent
            },
            {
                path: 'login/:offerSetUUID/:offerUUID',
                component: LoginComponent
            },
            {
                path: 'logout',
                component: LogoutComponent
            },
            {
                path: 'confirmationAccount',
                component: ConfirmationAccountComponent
            },
            {
                path: 'confirmationAccount/:offerSetUUID/:offerUUID',
                component: ConfirmationAccountComponent
            },
            {
                path: 'profile',
                redirectTo: '/settings/profile'
            },
            {
                path: 'membershipAccount',
                redirectTo: '/settings/memberships'
            },
            {
                path: 'accounts',
                redirectTo: '/settings/memberships'
            },
            {
                path: 'account/reactivate',
                component: NoOpComponent,
                resolve: {
                    _: 'TYTAppRedirect'
                },
                data: {
                    path: '/settings/memberships?reactivate=1'
                }
            },
            {
                path: 'account',
                pathMatch: 'full',
                redirectTo: '/settings/memberships'
            },
            {
                path: 'account/communication-pref',
                component: CommunicationPreferenceComponent
            },
            {
                path: 'account/communication-pref/:email/:profile_id',
                component: CommunicationPreferenceComponent
            },
            {
                path: 'changeMembership',
                redirectTo: 'membership/change'
            },
            {
                path: 'membership/change',
                component: ChangeMembershipComponent
            },
            {
                path: 'membership/change/products/:productID',
                component: ChangeMembershipConfirmationComponent
            },
            {
                path: 'membership/change/offers/:offerSetID/:offerID',
                component: ChangeMembershipConfirmationComponent
            },
            {
                path: 'settings',
                component: SettingsComponent
            },
            {
                path: 'settings/delete-data',
                component: NoOpComponent,
                resolve: {
                    _: 'TYTAppRedirect'
                },
                data: {
                    path: '/settings/delete-data'
                }
            },
            {
                path: 'settings/:section',
                component: SettingsComponent
            },
            {
                path: 'settings/:section/:subsection',
                component: SettingsComponent
            },
            {
                path: 'membership-settings',
                redirectTo: 'settings/memberships'
            },
            {
                path: 'membership/change/success',
                component: ChangeMembershipSuccessPageComponent
            },
            {
                path: 'changeMembership/success',
                redirectTo: 'membership/change/success'
            },
            {
                path: 'changeMembership/:product_sku',
                redirectTo: 'membership/change/products/:product_sku'
            },
            {
                path: 'cancelMembership',
                redirectTo: '/membership/cancel'
            },
            {
                path: 'cancelMembership/success',
                redirectTo: '/membership/cancel/success'
            },
            {
                path: 'membership/cancel',
                component: CancelMembershipComponent
            },
            {
                path: 'membership/cancel/success',
                component: CancelMembershipSuccessPageComponent
            },
            {
                path: 'updateBilling',
                redirectTo: '/billing/update'
            },
            {
                path: 'billing/update',
                component: UpdateBillingComponent
            },
            {
                path: 'updateBilling/success',
                redirectTo: '/billing/update/success'
            },
            {
                path: 'billing/update/success',
                component: UpdateBillingSuccessPageComponent
            },
            {
                path: 'changeEmail/success',
                component: ChangeEmailSuccessPageComponent
            },
            {
                path: 'faq',
                component: NoOpComponent,
                resolve: {
                    _: 'TYTAppRedirect'
                },
                data: {
                    path: '/about/faq'
                }
            },
            {
                path: 'engineering/assume/:token',
                component: AssumeComponent
            },
            {
                path: 'terms',
                component: RedirectComponent,
                data: { id: 'terms' }
            },
            {
                path: 'privacy',
                component: RedirectComponent,
                data: { id: 'privacy' }
            },
            {
                path: 'form/newsletter',
                component: NewsletterFormComponent
            },
            {
                path: 'community-values',
                redirectTo: '/core-values'
            },
            {
                path: 'core-values',
                component: RedirectComponent,
                data: { id: 'core-values' }
            },
            /* NOT FOUND */

            { path: 'w', children: [ { path: '**', component: BounceToAppComponent }] },
            {
                path: '**',
                component: PageNotFoundComponent
            }
        ]
    }
];


export const RoutingProviders = [
    {
        provide: 'TYTAppRedirect',
        useValue: TYTAppRedirect
    }
];


export function TYTAppRedirect(route: ActivatedRouteSnapshot) {
    const path = Object.entries(route.params)
        .reduce(
            (path, [key, value]) => path.replace(`:${key}`, value),
            route.data.path as string
        );

    window.location.href = `${environment.urls.app}${path}`;
}
